export const EShapeActionValueChangeColorType = wcardinal.ui.EShapeActionValueChangeColorType;